import React from "react";
import { ScheduleConfirmationTemplate } from "../../Templates/ScheduleConfirmationTemplate";

export const ScheduleConfirmation = () => {
  return <ScheduleConfirmationTemplate />;
};
